import React, { FC } from "react";
import { Box, Typography, Theme, useMediaQuery } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { UserExerciseDto } from "@growth-machine-llc/stridist-api-client";

export const useTooltipStyles = makeStyles((theme: Theme) => ({
  listItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontFamily: "Montserrat, sans-serif",
  },
  title: {
    textDecoration: "underline",
    color: theme.palette.primary.main,
    maxWidth: 200,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 14,
    marginRight: theme.spacing(1),
  },
}));

interface TooltipExerciseItemProps {
  userExercise: UserExerciseDto;
  count: number;
  onExerciseSelect: (exercise: UserExerciseDto) => void;
}

export const TooltipExerciseItem: FC<TooltipExerciseItemProps> = ({
  userExercise,
  onExerciseSelect,
  count,
}) => {
  const classes = useTooltipStyles();

  const handleSelectExercise = () => {
    onExerciseSelect(
      new UserExerciseDto({
        id: 0,
        exercise: userExercise.exercise,
        title: userExercise.title,
      }),
    );
  };

  return (
    <Box
      component="li"
      className={classes.listItem}
      onClick={handleSelectExercise}
    >
      <Box className={classes.title}>{userExercise.title}</Box>

      <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
        ({count} exercises)
      </Typography>
    </Box>
  );
};
